import { ColumnDef } from '@tanstack/react-table';
import { DataTable } from '@/components/common/DataTable';
import { GameProfitLoss } from '@/types';
import { exportCSV } from '@/utils/exportCSV';

export default function GameProfitLossPage() {
  const columns: ColumnDef<GameProfitLoss>[] = [
    { accessorKey: 'tableId', header: 'Table ID' },
    { accessorKey: 'tableName', header: 'Table Name' },
    {
      accessorKey: 'totalBet',
      header: 'Total Bet',
      cell: ({ row }) => `₹${row.original.totalBet}`,
    },
    {
      accessorKey: 'totalPayout',
      header: 'Total Payout',
      cell: ({ row }) => `₹${row.original.totalPayout}`,
    },
    {
      accessorKey: 'net',
      header: 'Net',
      cell: ({ row }) => {
        const net = row.original.net;
        return <span className={net >= 0 ? 'text-green-500' : 'text-red-500'}>₹{net}</span>;
      },
    },
  ];

  const data: GameProfitLoss[] = [
    {
      tableId: 'TBL1001',
      tableName: 'Dragon Arena 1',
      totalBet: 30000,
      totalPayout: 15000,
      net: 15000,
    },
    {
      tableId: 'TBL1002',
      tableName: 'Tiger Battle 4',
      totalBet: 22000,
      totalPayout: 18000,
      net: 4000,
    },
  ];

  const handleExport = (rows: GameProfitLoss[]) => {
    exportCSV({
      filename: 'game_profit_loss.csv',
      header: ['Table ID', 'Table Name', 'Total Bet', 'Total Payout', 'Net'],
      rows: rows.map((g) => [g.tableId, g.tableName, g.totalBet, g.totalPayout, g.net]),
    });
  };

  return (
    <>
      <div className="flex items-center justify-between mb-10">
        <div>
          <h2 className="text-3xl font-bold tracking-tight">Game Table Profit/Loss</h2>
          <p className="text-muted-foreground">
            Breakdown of net revenue per game table, showing bets placed vs payouts issued. Helps
            determine table performance and profitability.
          </p>
        </div>
      </div>
      <DataTable
        columns={columns}
        data={data}
        enableSelection={true}
        enableExport={true}
        onExport={handleExport}
        searchPlaceholder="Search game table..."
        pageIndex={0}
        total={0}
        onPageChange={function (page: number): void {
          throw new Error('Function not implemented.');
        }}
        onPageSizeChange={function (size: number): void {
          throw new Error('Function not implemented.');
        }}
      />
    </>
  );
}
